<template>
  <v-row no-gutters>
    <v-col>
      <a
        class="
          align-center
          background-color-seashell
          d-inline-flex
          font-size-sm
          nav-button-border-radius
          pl-1
          pr-3
        "
        @click="$router.back()"
      >
        <v-icon color="primary">mdi-chevron-left</v-icon>
        Back to {{ renderTextContent() }} Page
      </a>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "RouteBack",
  methods: {
    renderTextContent() {
      return this.textContent ? this.textContent : "Previous";
    },
  },
  props: { textContent: String },
};
</script>
